var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back_",style:({ top: _vm.$utils.px2rem(_vm.top + 'px') }),on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":require("@/assets/image/common/back_arrow.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }